<template>
  <section class="fmhind-tabs">
    <header class="fmhind-tabs__header">
      <Button
        class="fmhind-tabs__header-button"
        :color="selectedTab === index ? 'secondary' : 'primary'"
        v-for="(tab, index) in tabs"
        :key="tab.name"
        :text="tabNameTranslations[index]"
        @click.native="selectedTabName = tabNameTranslations[index]"
      />
      <Select
        class="fmhind-tabs__header-select"
        :options="tabNameTranslations"
        v-model="selectedTabName"
      />
    </header>
    <main class="fmhind-tabs__main">
      <component :is="tabs[selectedTab].component" />
    </main>
  </section>
</template>

<script>
import Select from '@/components/Ui/Select';
import Button from '@/components/Ui/Button';
import Education from '@/components/Tabs/Education';
import Areas from '@/components/Tabs/Areas';
import General from '@/components/Tabs/General';
// import Map from '@/components/Tabs/Map';

export default {
  name: 'Tabs',
  components: {
    Button,
    Select
  },
  data() {
    return {
      tabs: [
        // { name: 'Map', component: Map },
        { name: 'General', component: Education },
        { name: 'Education', component: Areas },
        { name: 'Areas', component: General }
      ],
      selectedTab: 0,
      selectedTabName: this.$t('Tab__General__name')
    };
  },
  computed: {
    tabNameTranslations() {
      return this.tabs.map(t => this.$t(`Tab__${t.name}__name`));
    }
  },
  watch: {
    selectedTabName: {
      immediate: true,
      handler(val) {
        this.selectedTab = this.tabNameTranslations.indexOf(val);
      }
    }
  }
};
</script>

<style lang="scss">
.fmhind-tabs__header {
  margin-bottom: $unit * 2;
}
.fmhind-tabs__header-button {
  margin-right: $unit * 1.5;

  @include media('<medium') {
    display: none;
  }
}

.fmhind-tabs__header-select {
  @include media('>medium') {
    display: none;
  }
}
</style>
